import React from "react";
import defaultAboutUsImage from "../../../assets/images/home-page/about-us/default-about-us-img.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  StyledAboutUsContentImage,
  StyledAboutUsContentInfo,
  StyledHomePageAboutUsBlock,
  StyledHomePageAboutUsContainer,
  StyledHomePageAboutUsWrapper
} from "./styledHomePageAboutUs";
import { StyledDecorationElementHomePage, StyledMainTitleHomePage } from "../styledHomePage";
import { StyledDecorationElement } from "../../styles/styledDocumentElements";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { HookResponsive } from "../../elements/customHooks/HookResponsive";

const HomePageAboutUs = () => {

  const aboutUsItemLeftAnimation = {
    hidden: {
      x: -50,
      opacity: 0
    },
    visible: custom => ({
      x: 0,
      opacity: 1,
      transition: { delay: custom * 0.2 }
    })
  };

  return (
    <StyledHomePageAboutUsWrapper
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <StyledHomePageAboutUsContainer>
        <StyledHomePageAboutUsBlock>
          <StyledAboutUsContentInfo>
            <motion.div
              custom={1}
              variants={HookResponsive() ? aboutUsItemLeftAnimation : null}
            >
              <StyledMainTitleHomePage
                color="#333333"
                position="start"
                className="main-title"
                as="h5"
                size="50"
                lineHeight="50"
                weight="700"
              >
                About us
              </StyledMainTitleHomePage>
            </motion.div>
            <StyledDecorationElementHomePage
              variants={HookResponsive() ? aboutUsItemLeftAnimation : null}
              custom={2}
              display="block"
              className="main-content"
              mt="30"
              weight="300"
              size="16"
              lineHeight="25"
            >
              Text me is the best multi-channel support chat on the site for your company. Looking for a chat widget
              that can effectively optimize your business? Then the online chatbot Text me was designed just for you and
              your customers! Automation of conversions using template responses, unlimited dialogs and contacts,
              integration with other messengers (Viber, Telegram), individual rates, as well as an adaptive design that
              is most suitable for your site. The ability to work from any mobile device or PC using the most popular
              operating systems, anytime, anywhere.
              The Text me project was developed with the aim of providing high-quality services and consultations for
              clients
              and customers, so that everyone could feel the benefits and advantages of this bot. The main principles of
              cooperation with Text me is respect for its customers, so we offer you a universal conversion enhancement
              widget
              that is suitable for absolutely any business.
              {" "}<StyledDecorationElement
              color="#9B68E4"
              size="16px"
              as={NavLink}
              to={{
                pathname: "/about-us",
                state: { manualKey: "aboutUs" }
              }}
            >Read more</StyledDecorationElement>
            </StyledDecorationElementHomePage>
          </StyledAboutUsContentInfo>
          <StyledAboutUsContentImage>
            <LazyLoadImage
              visibleByDefault={true}
              src={defaultAboutUsImage}
              alt=""
              width={660}
              height={440}
            />
          </StyledAboutUsContentImage>
        </StyledHomePageAboutUsBlock>
      </StyledHomePageAboutUsContainer>
    </StyledHomePageAboutUsWrapper>
  );
};
export default HomePageAboutUs;